// @avantia common-code
import { hasWindowRef } from '@avantia/client-and-server-utilities';

export const nbsp = String.fromCharCode(160);
export const bullet = String.fromCharCode(8226);
export const apos = String.fromCharCode(8217);
export const dagger = String.fromCharCode(8224);

export function formatNumber(value: number | null, defaultValue = ''): string {
  if (value !== null && value !== undefined && !isNaN(value)) {
    return numberToString(value);
  }

  return defaultValue;
}

export interface HpFormatCurrencyOptions {
  defaultValue?: string;
  includePence?: boolean;
  includeSymbol?: boolean;
}

export function formatCurrency(value: number | null, options?: string | HpFormatCurrencyOptions): string {
  if (typeof options === 'string') {
    options = { defaultValue: options };
  }

  const { defaultValue = '', includePence = true, includeSymbol = false } = options || {};

  let res = formatNumber(value, defaultValue);

  if (res === defaultValue) {
    return res;
  }

  const len = res.length;
  const ix = res.indexOf('.');
  if (ix < 0) {
    res += '.00';
  } else if (ix === len - 2) {
    res += '0';
  } else if (len > ix + 3) {
    res = numberToString(Math.round(parseFloat(res) * 100) / 100.0);
  }

  if (!includePence) {
    res = res.split('.')[0];
  }

  if (includeSymbol) {
    res = '£' + res;
  }

  return res;
}

function numberToString(value: number): string {
  return value.toLocaleString('en-GB');
}

let origDocumentTitle: string | undefined;

export function updateDocumentTitle(withName: { name: string }): void {
  if (!hasWindowRef()) {
    return;
  }

  if (!origDocumentTitle) {
    origDocumentTitle = document.title;
  }

  document.title = `${origDocumentTitle} ${bullet} ${withName.name}`;
}
